@if (data(); as data) {
  <div class="bg-kz-layout-featured">
    <div class="border-bottom p-2">
      <div class="font-medium flex flex-row gap-1 items-center">
        {{ data.hotel?.hotelName }}
        <app-stars class="pb-1" [stars]="data.hotel?.hotelClass" />
      </div>
      <div class="text-secondary">{{ data.hotel?.cityName }}, {{ data.hotel?.districtName }}</div>
    </div>
    <div class="details-list p-2">
      <div>
        <mat-icon svgIcon="fill-calendar" color="primary" />
        {{ data.hotel?.checkInDate | date }} — {{ data.hotel?.checkOutDate | date }} ({{
          'NIGHTS_COUNT' | translate: { value: data.hotel?.nights }
        }})
      </div>
      @if (data.hotel?.roomCategoryName) {
        <div>
          <mat-icon svgIcon="fill-bed" color="primary" />
          {{ data.hotel.roomCategoryName }},
          @if (data.hotel.placementTypeName) {
            {{ data.hotel.placementTypeName }}
          }
        </div>
      }
      @if (data.hotel?.mealPlan) {
        <div>
          <mat-icon svgIcon="fill-nutrition" color="primary" />
          {{ data.hotel.mealPlan }}
        </div>
      }
      @if (data.hotel?.adults) {
        <div>
          <mat-icon svgIcon="user" color="primary" />
          {{ 'ADULTS_COUNT' | translate: { value: data.hotel.adults } }}
        </div>
      }
      @if (data.hotel?.children) {
        <div>
          <mat-icon svgIcon="child" color="primary" />
          {{ 'CHILDREN_COUNT' | translate: { value: data.hotel.children } }}
          @if (data.hotel._extraParams?.ages) {
            (
            {{ data.hotel._extraParams.ages.join(', ') }}
            )
          }
        </div>
      }
    </div>
  </div>
  <!-- R-C37 / R-HT20 (website-web#71): the transfer chosen in Details stays with the hotel - its parts, and the card's price includes it -->
  @if (transfer()?.price) {
    <div class="text-sm flex flex-row flex-wrap justify-center gap-1 mt-2" data-testid="cart-hotel-item-transfer">
      <span data-testid="cart-hotel-item-transfer-hotel"
        >{{ 'Hotel' | translate }} {{ data.totalPrice | priceFormat: data.priceCurrency }}</span
      >
      <span data-testid="cart-hotel-item-transfer-transfer"
        >+ {{ 'transfer' | translate }} {{ transfer()!.price | priceFormat: data.priceCurrency }}</span
      >
    </div>
  }
  <div class="text-kz-primary font-bold w-full text-center mt-2 mb-3" data-testid="cart-hotel-item-price">
    {{ total() | priceFormat: data.priceCurrency }}
  </div>
}
